import { DateObject } from "react-multi-date-picker";
import {
  ClientInvoicePeakSurchargeUIRequest,
  EditClientInvoiceUIRequest,
} from "../ClientInvoiceInterfaces";
import { UpdatePeakSurcharge } from "../../ratecard/dtos/UpdateRateCardRequest";
import {
  convertStringToDateTime,
  formatDateTime,
} from "../../../../components/common/utils/DateUtils";

export const mapValuesUiRequestToUpdatePeakSurcharge = (
  uiRequest: EditClientInvoiceUIRequest,
  invoiceStatus: string
): UpdatePeakSurcharge[] => {
  let peakSurchargeList: UpdatePeakSurcharge[] = [];

  // show peak surcharge
  if (uiRequest.show_peak_surcharge) {
    if (uiRequest.peakSurcharge.length > 0) {
      uiRequest.peakSurcharge.forEach((surcharge) => {
        if (
          surcharge.peakSurchargeType &&
          surcharge.peakSurchargeType &&
          (surcharge.peak_surcharge_value_percentage ||
            surcharge.peak_surcharge_value_dollar)
        ) {
          let peakSurchargeItem: UpdatePeakSurcharge = {
            peakSurchargeId:
              invoiceStatus !== "generated"
                ? surcharge.peakSurchargeId
                : undefined,
            isActive: true,
            peakSurchargeMinDate: formatDateTime(
              surcharge.peak_surcharge_date_range[0].toDate()
            ),
            peakSurchargeMaxDate: formatDateTime(
              surcharge.peak_surcharge_date_range[1].toDate()
            ),
            peakSurchargeType: surcharge.peakSurchargeType,
            peakSurchargeValue:
              (surcharge.peakSurchargeType === "percentage"
                ? surcharge.peak_surcharge_value_percentage
                : surcharge.peak_surcharge_value_dollar) ?? 0,
          };
          peakSurchargeList.push(peakSurchargeItem);
        }
      });
    }
  }
  return peakSurchargeList;
};

function safeFormatDate(input:any, fallback = new Date()) {
  if (!input) return fallback; // Return fallback if input is null or undefined
  if (typeof input.toDate === 'function') {
    const date = input.toDate();
    return date instanceof Date ? date : fallback; // Ensure the result is a Date
  }
  return input instanceof Date ? input : fallback; // If input is already a Date, return it; otherwise, return fallback
}

export const mapUpdatePeakSurchargeToUiRequest = (
  peakSurchargeList: UpdatePeakSurcharge[] | undefined
): ClientInvoicePeakSurchargeUIRequest[] => {
  let uiRequestList: ClientInvoicePeakSurchargeUIRequest[] = [];

  if (peakSurchargeList && peakSurchargeList.length > 0) {
    peakSurchargeList.forEach((surcharge) => {
      const minDate = safeFormatDate(surcharge.peakSurchargeMinDate);
      const maxDate = safeFormatDate(surcharge.peakSurchargeMaxDate);
      let uiItem: ClientInvoicePeakSurchargeUIRequest = {
        peakSurchargeId: surcharge.peakSurchargeId ?? undefined,
        peak_surcharge_date_range: [
          new DateObject().setDate(minDate),
          new DateObject().setDate(maxDate),
        ],
        peakSurchargeType: surcharge.peakSurchargeType,
        peak_surcharge_value_percentage:
          surcharge.peakSurchargeType === "percentage"
            ? surcharge.peakSurchargeValue
            : undefined,
        peak_surcharge_value_dollar:
          surcharge.peakSurchargeType === "value"
            ? surcharge.peakSurchargeValue
            : undefined,
      };
      uiRequestList.push(uiItem);
    });
  }

  if (uiRequestList.length == 0) {
    uiRequestList = [
      {
        peakSurchargeType: null,
      peak_surcharge_date_range: [],
        peak_surcharge_value_dollar: undefined,
        peak_surcharge_value_percentage: undefined,
      },
    ];
  }

  return uiRequestList;
};
